import { serializeUrlSearchParams } from '@seamapi/url-search-params-serializer';
import axios, {} from 'axios';
import axiosRetry, { exponentialDelay } from 'axios-retry';
import { errorInterceptor } from './error-interceptor.js';
export const createClient = (options) => {
    const client = axios.create({
        paramsSerializer: serializeUrlSearchParams,
        adapter: 'fetch',
        ...options.axiosOptions,
    });
    axiosRetry(client, {
        retries: 2,
        retryDelay: exponentialDelay,
        ...options.axiosRetryOptions,
    });
    client.interceptors.response.use(undefined, errorInterceptor);
    return client;
};
//# sourceMappingURL=client.js.map